import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import config from "../../config";
import endpoints from "../../api/endpoints";
import api from "../../api/apiClient";
import { DatePicker, message, Modal } from "antd";
import dayjs from "dayjs";
import CustomTable from "../../components/CommonComponents/CustomTable";
import { render } from "@testing-library/react";
import { addCommaToNumber, getDecoded, getPercentage } from "../../util";
import { useNavigate } from "react-router-dom";
import { ButtonBase } from "@mui/material";

const {RangePicker} = DatePicker;
const Dashboard = props => {

  const [date,setDate] = useState({startDate: "",endDate: ""});
  const [tableLoading, setTableLoding] = useState(false);
  const [trnx, setTrnx] = useState([]);
  const [totalCommission, setTotalCommission] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalDeposit, setTotalDeposit] = useState(0);
  const [totalWithdraw, setTotalWithdraw] = useState(0);
  const [totalDepositUser, setTotalDepositUser] = useState(0);
  const [totalWithdrawUser, setTotalWithdrawUser] = useState(0);
  const [totalUsersByDateRange, setTotalUsersByDateRange] = useState(0);
  const navigate = useNavigate();
  
  const [page, setPage] = useState(1);

  const mounted = useRef(false);

  const getData = async () => {
    setTableLoding(true);
    const res = await api.get(endpoints.agent.getDashboardData + `?startDate=${date.startDate}&endDate=${date.endDate}&page=${page}`);
    setTableLoding(false);
    if(res.code !== '200') return message.error(res.message);
    setTrnx(res.data?.dailyCommission);
    setTotalRows(res.data?.total?.totalRows);
    setTotalCommission(res.data?.total?.totalCommission);
    setTotalUsers(res.data?.total?.totalUsers);
    setTotalDeposit(Number(res.data?.total?.totalDeposit));
    setTotalDepositUser(res.data?.total?.totalDepositUser);
    setTotalWithdraw(Number(res.data?.total?.totalWithdraw));
    setTotalWithdrawUser(res.data?.total?.totalWithdrawUser);
    setTotalUsersByDateRange(res.data?.total?.totalUsersByDateRange);
  }

  const handleDateChange = (value, dateString) => {
    const startDate = dayjs(value[0]);
    const endDate = dayjs(value[1]);
    const diffInDays = endDate.diff(startDate, "day");

    if (diffInDays > 30) {
      message.error("The date range cannot exceed 30 days!");
      return;
    }

    setDate({startDate: dateString[0],endDate: dateString[1]});
    setPage(1);
  }

  const viewDepositAndWithdrawUsers = async (type = 'purchase') => {
    const UI = () => {
      const [modalLoading, setModalLoading] = useState(false);
      const [users, setUsers] = useState([]);
      const [totalUsers, setTotalUsers] = useState(0);
      const [page, setPage] = useState(1);

      const getData = async () => {
        setModalLoading(true);
        const res = await api.get(endpoints.agent.getDepositAndWithdrawUsers + `?startDate=${date.startDate}&endDate=${date.endDate}&type=${type}&page=${page}`);
        setModalLoading(false);
        if(res.code !== "200") return message.error(res.message);
        setUsers(res.data?.users);
        setTotalUsers(res.data?.total?.totalUserRows)
      }

      useEffect(() => {
        getData();
      },[page]);

      const modalColumns = [
        {
          title: "Name",
          key: 'name',
          render: ({name, user_id}) => {
            const handleIdClick = () => {
              Modal.destroyAll();
              navigate("/user/detail/"+ user_id);
            }
            return <ButtonBase onClick={handleIdClick}>{name}</ButtonBase>
          }
        },
        {
          title: "Reason",
          dataIndex: 'action',
          key: 'action',
        },
        {
          title: "Adjust",
          dataIndex: 'adjust_amount',
          key: 'adjust_amount',
        },
        {
          title: "Date",
          dataIndex: 'logged_date',
          key: 'logged_date',
        },
      ];

      return (
        <div style={{marginTop: "20px"}}>
          <CustomTable
            rowHeight={13}
            data={users}
            pageSize={5}
            columns={modalColumns}
            loading={modalLoading}
            handlePageChange={(v) => setPage(v)}
            page={page}
            totalUsers={totalUsers}
          />
        </div>
      )
    }
    Modal.confirm({
      title: `${type === 'purchase' ? 'Deposit' : 'Withdraw'} Users`,
      width: "500px",
      content: <UI/>,
      centered: true,
      cancelButtonProps: {style: {display: "none"}},
      okButtonProps: {style: {display: "none"}},
      closable: true,
      closeIcon: <i className="mdi mdi-close-thick" style={{fontSize: "18px", color: config.color.textColor}}></i>,
    });
  }

  useEffect(() => {
    if(!mounted.current) return;
    getData();
  },[page, date])

  useEffect(() => {
    mounted.current = true;
    const today = dayjs();
    const startDate = today.subtract(30, 'day').format('YYYY-MM-DD');
    const endDate = today.format('YYYY-MM-DD');
    setDate({ startDate: startDate, endDate: endDate });
  },[]);

  const Header = () => {
    const reports = [
      { title: "Total Users", iconClass: "bx-user", description: addCommaToNumber(totalUsers) },
      { title: "Total Users(Date)", iconClass: "bx-user", description: addCommaToNumber(totalUsersByDateRange) },
      { title: "Total Commission", iconClass: "bx-archive-in", description: addCommaToNumber(totalCommission) },
      {
        title: "Share Commission",
        iconClass: "bx-purchase-tag-alt",
        description: <span style={{color: config.color.yellow}}>{addCommaToNumber(getPercentage(totalCommission, getDecoded().commission))}</span>,
      },
      {
        title: "Owner Commission",
        iconClass: "bx-purchase-tag-alt",
        description: addCommaToNumber(totalCommission - getPercentage(totalCommission, getDecoded().commission)),
      },
      { title: "Total Deposit/User", iconClass: "bx-user", description: <div style={{display: 'flex', alignItems: "center"}}>{addCommaToNumber(totalDeposit)}/<ButtonBase style={{textDecoration: "underline"}} component='div' onClick={()=> viewDepositAndWithdrawUsers('purchase')}>{addCommaToNumber(totalDepositUser)}</ButtonBase></div> },
      { title: "Total Withdraw/User", iconClass: "bx-user", description: <div style={{display: 'flex', alignItems: "center"}}>{addCommaToNumber(totalWithdraw)}/<ButtonBase style={{textDecoration: "underline"}} component='div' onClick={()=> viewDepositAndWithdrawUsers('withdraw')}>{addCommaToNumber(totalWithdrawUser)}</ButtonBase></div> },
      { title: "Deposit-Withdraw", iconClass: "bx-user", description: <span style={{color: totalDeposit - totalWithdraw >= 0 ? config.color.green : config.color.red}}>{addCommaToNumber(totalDeposit - totalWithdraw)}</span>},
    ];

    return (
      <Row>
        {(reports || [])?.map((report, key) => (
          <Col md="3" key={"_col_" + key}>
            <Card className="mini-stats-wid">
              <CardBody>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <p className="" style={{color: config.color.textColor}}>
                      {report.title}
                    </p>
                    <h4 className="mb-0">{report.description}</h4>
                  </div>
                  <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                    <span className="avatar-title rounded-circle " style={{backgroundColor: config.color.secondaryColor}}>
                      <i className={"bx " + report.iconClass + " font-size-24"}></i>
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    )
  }

  const Body = () => {
    const columns = [
      {
        title: "Date",
        dataIndex: 'date',
        key: 'date',
      },
      {
        title: "Total Commission",
        dataIndex: 'totalCommission',
        key: 'totalCommission',
        render: (totalCommission) => {
          return addCommaToNumber(totalCommission);
        }
      },
      {
        title: "Share Commission",
        dataIndex: 'totalCommission',
        key: 'totalCommission',
        render: (totalCommission) => {
          return addCommaToNumber(getPercentage(totalCommission, getDecoded().commission))
        }
      },
      {
        title: "Owner Commission",
        dataIndex: 'totalCommission',
        key: 'totalCommission',
        render: (totalCommission) => {
          return addCommaToNumber(totalCommission - getPercentage(totalCommission, getDecoded().commission))
        }
      },
    ];

    return (
      <div>
        <div style={{display: 'flex', gap: "20px", alignItems: "center", marginTop: "30px"}}>
          <RangePicker
            dropdownClassName={"createDateRangePicker"}
            style={{backgroundColor: "#2A3042", border: 0, color: config.color.textColor}}
            value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
            onChange={(v,dateString)=> handleDateChange(v,dateString)}
          />
        </div>
        <div style={{marginTop: "20px"}}>
          <CustomTable
            rowHeight={13}
            data={trnx}
            columns={columns}
            loading={tableLoading}
            handlePageChange={(v) => setPage(v)}
            page={page}
            totalUsers={totalRows}
          />
        </div>
      </div>
    )
  }
  
  return (
    <React.Fragment>
      <div className="page-content">
         <Header/>
         <Body/>
      </div>
    </React.Fragment>
  );
};


export default Dashboard;
